import { AdPlacement } from "@/components/ads/AdPlacement";
import { m } from "@/paraglide/messages";
import { McBreadcrumb } from "../components/McBreadcrumb";
import { McExplainer } from "../components/McExplainer";
import { MorseTool } from "../components/MorseTool";

export function MorseCodePage() {
  return (
    <div className="relative">
      <div className="pointer-events-none absolute inset-0 gradient-mesh" />
      <div className="relative mx-auto max-w-3xl px-4 py-12 sm:px-6 lg:px-8">
        <McBreadcrumb />

        <header className="mb-8 mt-6">
          <h1 className="font-display text-3xl font-bold tracking-tight sm:text-4xl">
            {m.mc_h1()}
          </h1>
          <p className="mt-3 leading-relaxed text-muted-foreground">
            {m.mc_intro()}
          </p>
        </header>

        <MorseTool />

        <McExplainer
          howTo={m.mc_howto()}
          faqs={[
            { q: m.mc_faq1_q(), a: m.mc_faq1_a() },
            { q: m.mc_faq2_q(), a: m.mc_faq2_a() },
            { q: m.mc_faq3_q(), a: m.mc_faq3_a() },
            { q: m.mc_faq4_q(), a: m.mc_faq4_a() },
          ]}
        />

        <AdPlacement className="mt-10" />
      </div>
    </div>
  );
}
